import React, { useState } from "react";
import { Document, Packer, Paragraph, TextRun } from "docx";
import { saveAs } from "file-saver";
import { FaMobileAlt } from "react-icons/fa";
import { MdOutlineMail } from "react-icons/md";
import { FaLinkedin, FaLocationDot } from "react-icons/fa6";
import { TbWorld } from "react-icons/tb";


const Home = () => {
    const [formData, setFormData] = useState({
        name: "",
        rollNumber: "",
        mobileNumber: "",
        email: "",
        linkedin: "",
        website: "",
        location: "",
        skills:"",
        bachelors:"",
        bachelorsYear:"",
        universityName:"",
        masters:"",
        mastersYear:"",
        universityNames:""
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const downloadDocx = () => {
        const doc = new Document({
            sections: [
                {
                    properties: {},
                    children: [
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: "Form Data",
                                    bold: true,
                                    size: 28,
                                }),
                            ],
                        }),
                        new Paragraph(""),
                        new Paragraph(`${formData.name}`),
                        new Paragraph(`Roll Number: ${formData.rollNumber}`),
                    ],
                },
            ],
        });

        Packer.toBlob(doc).then((blob) => {
            saveAs(blob, "form-data.docx");
        });
    };

    return (
        <div className="container-fluid p-4" style={{ backgroundColor: '#F2F3B7' }}>
            <div className="row">
                <div className="col-md-4 dynamic_docs">
                    <div className="row">
                        <div className="col-12">Name</div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">Designation</div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <input
                                type="text"
                                name="rollNumber"
                                value={formData.rollNumber}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">Mobile Number</div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <input
                                type="text"
                                name="mobileNumber"
                                value={formData.mobileNumber}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">Email Address</div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <input
                                type="text"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">Linkedin</div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <input
                                type="text"
                                name="linkedin"
                                value={formData.linkedin}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">Website</div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <input
                                type="text"
                                name="website"
                                value={formData.website}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">Location</div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <input
                                type="text"
                                name="location"
                                value={formData.location}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">Skills</div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <input
                                type="text"
                                name="skills"
                                value={formData.skills}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">Bachelors degree</div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <input
                                type="text"
                                name="bachelors"
                                value={formData.bachelors}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">Bachelors year</div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <input
                                type="text"
                                name="bachelorsYear"
                                value={formData.bachelorsYear}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">University Name</div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <input
                                type="text"
                                name="universityName"
                                value={formData.universityName}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">Master's degree</div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <input
                                type="text"
                                name="masters"
                                value={formData.masters}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">Master's year</div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <input
                                type="text"
                                name="mastersYear"
                                value={formData.mastersYear}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">University Name</div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <input
                                type="text"
                                name="universityNames"
                                value={formData.universityNames}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">Hindi</div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <input
                                type="text"
                                name="hindi"
                                value={formData.hindi}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">English</div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <input
                                type="text"
                                name="english"
                                value={formData.english}
                                onChange={handleChange}
                            />
                        </div>
                    </div>


                </div>

                <div className="col-md-1"></div>

                <div className="col-md-7 dynamic_docs">
                    <p style={{ textAlign: "center", fontSize: '40px', fontWeight: 'bold', textTransform: 'uppercase' }}>{formData.name}</p>
                    <p style={{ textAlign: "center", fontSize: '20px', textTransform: 'uppercase' }}> {formData.rollNumber}</p>
                    <hr style={{ height: "2px", borderWidth: "0", color: "gray", backgroundColor: "gray" }} />
                    <div className="row">
                        <div className="col-md-5 text-muted" style={{ background: '#f2f3b7' }}>
                            <div className="row">
                                <div className="col-12">CONTACT</div>
                            </div>
                            <div className="row">
                                <div className="col-2"><FaMobileAlt /> </div>
                                <div className="col-10">{formData.mobileNumber}</div>
                            </div>
                            <div className="row">
                                <div className="col-2"><MdOutlineMail /> </div>
                                <div className="col-10">{formData.email}</div>
                            </div>
                            <div className="row">
                                <div className="col-2"><FaLinkedin /> </div>
                                <div className="col-10">{formData.linkedin}</div>
                            </div>
                            <div className="row">
                                <div className="col-2"><TbWorld /> </div>
                                <div className="col-10">{formData.website}</div>
                            </div>
                            <div className="row">
                                <div className="col-2"><FaLocationDot /> </div>
                                <div className="col-10">{formData.location}</div>
                            </div>
                            <hr/>
                            <div className="row">
                                <div className="col-12">SKILLS</div>
                            </div>
                            <div className="row">
                                <div className="col-10">{formData.skills}</div>
                            </div>
                            <div className="row">
                                <div className="col-12">EDUCATION</div>
                            </div>
                            <div className="row">
                                <div className="col-10">{formData.bachelors}</div>
                            </div>
                            <div className="row">
                                <div className="col-10">{formData.bachelorsYear}</div>
                            </div>
                            <div className="row">
                                <div className="col-10">{formData.universityName}</div>
                            </div>

                            <div className="row">
                                <div className="col-10">{formData.masters}</div>
                            </div>
                            <div className="row">
                                <div className="col-10">{formData.mastersYear}</div>
                            </div>
                            <div className="row">
                                <div className="col-10">{formData.universityNames}</div>
                            </div>

                            <div className="row">
                                <div className="col-12">LANGUAGE</div>
                            </div>
                            <div className="row">
                                <div className="col-10">Hindi: {formData.hindi}</div>
                            </div>
                            <div className="row">
                                <div className="col-10">English: {formData.english}</div>
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="row">
                                <div className="col-12">PROFILE</div>
                            </div>
                        </div>
                    </div>
                    <button onClick={downloadDocx}>Download as DOCX</button>
                </div>
            </div>
        </div>
    );
};

export default Home;
